<template>
  <div id="app">
    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">Cari Hareketler</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field flat="" solo-inverted="" hide-details v-model="search" label="Ara" append-icon="search"></v-text-field>
            <a target="_self" v-bind:href="'#/carihareketler/yeni/'">
              <v-btn flat> <span class="hidden-sm-and-down"> Cari Hareket Ekle </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
            </a>
          </v-toolbar>
        </v-flex>
        <v-container fluid>

          <v-layout row wrap>
            <v-flex xs12 sm4 md2>


            <tarihim :etiket="'Başlangıç Tarihi'" :detaygizle="false" v-model="date" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>

            </v-flex>
            <v-flex xs12 sm4 md2>
              <tarihim :etiket="'Bitiş Tarihi'" :detaygizle="false" v-model="date2" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
            </v-flex>




            <v-flex>

              <v-layout>
                <div v-if="load1">
                  <v-btn color="info" @click="CarihareketGetir()" fab small="" dark>
                    <v-icon>search</v-icon>
                  </v-btn>
                </div>
                <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click.native="dialogfiltre=true"
                  color="info" fab dark>
                  <v-icon>filter_list</v-icon>
                </v-btn>
                <v-tooltip bottom="" :activator="el" v-model="tooltip">
                  <span>Arama Filtresi Ekle</span>
                </v-tooltip>
              </v-layout>
            </v-flex>







            <v-flex xs12 sm12>
              <v-card-title>
                <v-spacer></v-spacer>

              </v-card-title>
              <v-data-table :headers="headers" :loading="progress" :rows-per-page-items=[50,100] :items="items" :search="search">
                <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                <template slot="items" slot-scope="props">
                  <tr @click="git(props.item)" item>
                    <td class="text-xs-left">{{ props.item.Cari.Kod }}</td>
                    <td class="text-xs-left">{{ props.item.Cari.Unvan }}</td>
                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                    <td class="text-xs-left">{{ props.item.Evrak.Evrakkod }}</td>
                    <td class="text-xs-left">{{ props.item.Evrakno }}</td>
                    <td class="text-xs-left">{{ props.item.Aciklama }}</td>
                    <td class="text-xs-left">{{ props.item.BA }}</td>
                    <td class="text-xs-right">{{ props.item.Tutar | moneyformat }}</td>
                    <td class="text-xs-left">{{ props.item.Faturano }}</td>
                    <td class="text-xs-left">{{ props.item.Referans.Kod }}</td>
                  </tr>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                  Aradığınız "{{ search }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                </v-alert>
              </v-data-table>
            </v-flex>
            <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
              :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
              {{ text1 }}
              <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
            </v-snackbar>

            <v-dialog v-model="dialog" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">Uyarı !</v-card-title>
                <v-card-text>{{dialogmessage}}</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" flat @click.native="karsicariac()">Tamam</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>


            <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
              <v-card color="grey lighten-5">

                <v-card-title>Filtre Seçimi</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-flex mt-2 xs12 sm12 md12>
                    <v-card class="white--text">
                      <v-card flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">
                            <div class="flex md12">
                              <v-autocomplete hide-details clearable="" label="Cari Hesap" append-icon="search"
                                autocomplete :loading="loading" :items="statecari" item-text="text" v-model="CariHareketInput.CariKodu"
                                cache-items="" item-value="id" :search-input.sync="searchcari"></v-autocomplete>
                              <v-flex xs12 sm12 md12>
                                <referansmerkezicomp :detaygizle="'true'" v-model="CariHareketInput.Filtreler.Referans"></referansmerkezicomp>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                <masrafmerkezicomp :detaygizle="'true'"  v-model="CariHareketInput.Filtreler.Masraf"></masrafmerkezicomp>
                              </v-flex>
                              <v-layout>
                              <v-flex xs12 sm6 md6>
                                <parainput v-model="CariHareketInput.Filtreler.BaslangicTutar" :etiket="'Tutar Başlangıç'"
                                  :autocomplete="'autocomplete'"></parainput>
                              </v-flex>
                              <v-flex xs12 sm6 md6>
                                <parainput :detaygizle="'true'" v-model="CariHareketInput.Filtreler.BitisTutar" :etiket="'Tutar Bitiş'"
                                  :autocomplete="'autocomplete'"></parainput>
                              </v-flex>
</v-layout>
                               <v-autocomplete hide-details :items="evraktipi" v-model="CariHareketInput.Filtreler.EvrakTipi" label="Evrak Tipi"
                              item-text="Title" item-value="Evrakkod">

                            </v-autocomplete>


                              <v-text-field hide-details="" v-model="CariHareketInput.Filtreler.EvrakNo" aria-multiline=""
                                label="Evrak No"></v-text-field>
                              <v-text-field hide-details="" v-model="CariHareketInput.Filtreler.FaturaNo"
                                aria-multiline="" label="Fatura No"></v-text-field>

                            </div>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" flat @click.native="dialogfiltre=false">İptal</v-btn>
                  <v-btn color="blue darken-1" flat @click="CarihareketGetir()">Filtreleri Uygula</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>




          </v-layout>
        </v-container>

        <v-container fluid>
          <v-layout row wrap>

          </v-layout>
        </v-container>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import parainput from '../customcomp/parainput'
  import dovizinput from '../customcomp/dovizinput'
  import yuzdeinput from '../customcomp/yuzdeinput'
  import tarihim from '../customcomp/tarihim'
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
  import helpers from "@/components/app/customcomp/helpers.js"

  export default {
    data() {
      return {
        search: '',
        headers: [{
            text: 'Hesap',
            value: 'Cari.Kod'
          },
          {
            text: 'Ünvan ',
            value: 'Cari.Unvan',
          },
          {
            text: 'Tarih',
            value: 'Tarih',

          },
          {
            text: 'Evrak Tipi',
            value: 'Evrak.Evrakkod'
          },
          {
            text: 'Evrak No',
            value: 'Evrakno'
          },
          {
            text: 'Açıklama',
            value: 'Aciklama'
          },
          {
            text: 'B/A',
            value: 'BA'
          },
          {
            text: 'Tutar',
            value: 'Tutar',
            align: 'right'
          },
          {
            text: 'Fatura No',
            value: 'Faturano'
          },
          {
            text: 'Referans',
            value: 'Referans.Kod'
          }
        ],
        date: null,
        islemdurumu: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        harekettipi: '',
        items: [],

        CariHareketInput: {
          SirketKodu: null,
          BaslangicTarihi: null,
          BitisTarihi: null,
          CariKodu: null,
          Filtreler: {
            Referans: null,
            Masraf: null,
            BaslangicTutar: 0,
            BitisTutar: 0,
            EvrakNo: null,
            EvrakTipi: null,
            FaturaNo: null,
          },
          Entegre: false,
          ListTipi: 0, // 0 : Hepsi, 1 : Bilet Kayıtları Hariç

        },


        CariHareket: {
          Account: '',
          movementCounter: '',
          Title: '',
          Date: '',
          DocumentType: '',
          DocumentNumber: '',
          Explanation: '',
          Ba: '',
          Amount: '',
          InvoiceNumber: '',
          Reference: '',
          Id: '',
          OrderNumber: '',
          CompanyCode: ''
        },
        Movement: {
          Current: '',
          Nereden: '',
          SirketKodu: '',
          Tarih: null,
          DefID: ''
        },
        tooltip: false,
        el: null,
        StartDate: null,
        EndDate: null,
        load: false,
        load1: true,
        dialogmessage: '',
        dialog: false,
        progress: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        statecari: [],
        loading: false,
        searchcari: null,
        dialogfiltre: false,
        evraktipi:[],
        dictionary: {
          custom: {

            tarihsecbas: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsecbit: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },
      }
    },
    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      }
    },
   filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    methods: {


      carigetir(v) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var query = {
          q: v,
          c: credentials.SirketKodu,
          FullSimple:false
        }

        if (v.length >= 0) {
          this.loading = true
          setTimeout(() => {
            this.$http.post(auth.API_URL + 'api/Options/CurrentSearch', query, { headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.statecari = response.body

            }, (response) => {
              if (response.status === 0) {
                this.text = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text = 'Service Unavailable'
                this.snackbar = true
              }
            })
            this.loading = false
          }, 500)
        }
      },

      CarihareketGetir: CarihareketGetir,
      getDateNow: getDateNow,
      karsicariac: karsicariac,
      git: git
    },
    beforeMount: beforeMount,
    components: {
      'parainput': parainput,
      'dovizinput': dovizinput,
      'yuzdeinput': yuzdeinput,
     tarihim,
      referansmerkezicomp,
      masrafmerkezicomp,
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el
    },


  }

  function karsicariac() {

    if (this.islemdurumu == 2) {
      var url1 = '#/carihareketler/duzenle/id?' + 'ac=' + this.CariHareket.Account + '&dt=' + this.CariHareket.Date +
        '&on=' + this.CariHareket.OrderNumber
      window.open(url1, '_target')
      this.dialog = false
    } else {
      this.dialog = false
    }


  }


  function git(v) {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var GetMovement = {
      CompanyCode: credentials.SirketKodu,
      Date: v.Tarih,
      AccountCode: v.Cari.Kod,
      OrderNumber: v.Sirano
    }
    this.$http.post(auth.API_URL + 'api/CurrentMovement/Get', GetMovement, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.Movement.Nereden = response.body.Nereden
      this.Movement.SirketKodu = response.body.SirketKodu
      this.Movement.DefID = response.body.TanimID
      this.Movement.Date = response.body.Tarih

      var params = {
        Whereis: response.body.Nereden,
        CompanyCode: response.body.SirketKodu,
        DefID: response.body.TanimID,
        Date: response.body.Tarih
      }

      this.$http.post(auth.API_URL + 'api/CurrentMovement/ShowContr', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {




        if (response.body.Status === true) {
          console.log('statuts true')
          this.islemdurumu = 0
          var url = '#/carihareketler/duzenle/id?' + 'ac=' + v.Cari.Kod + '&dt=' + v.Tarih + '&on=' + v.Sirano
          window.open(url, '_target')

        } else {

          if (response.body.StatusType == 1) {
            console.log('statuStype 1')
            this.islemdurumu = 1

            this.dialog = true
            this.dialogmessage = response.body.ResponseMessage

          } else if (response.body.StatusType == 2) {
            console.log('statuStype 2')
            this.islemdurumu = 2


            this.dialog = true
            this.dialogmessage = response.body.ResponseMessage

            this.CariHareket.Account = response.body.CariLoad.Cari.Kod
            this.CariHareket.Date = response.body.CariLoad.Tarih
            this.CariHareket.OrderNumber = response.body.CariLoad.Sirano
            this.CariHareket.CompanyCode = response.body.CariLoad.SirketKodu


          }
        }
      })
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

  }

  function beforeMount() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.progress = true
    this.load = true
    this.load1 = false
    this.date = getDateNow()
    this.date2 = getDateNow()
    this.CariHareketInput.BaslangicTarihi=this.date
    this.CariHareketInput.BitisTarihi=this.date2
    this.CariHareketInput.SirketKodu=credentials.SirketKodu


    var Params = this.CariHareketInput
    this.$http.post(auth.API_URL + 'api/movement/index', Params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body
      this.progress = false
      this.load = false
      this.load1 = true
      this.error = false
    }, (response) => {
      if (response.status === 0) {
        this.load1 = true
        this.progress = false

        this.error = false
        this.error = 'Service Unavailable'
      } else {
        this.error = response.statusText
        this.load1 = true
        this.progress = false

        this.error = false
      }
    })

    var params1 = {
      CompanyCode: credentials.SirketKodu,

    }
      this.$http.post(auth.API_URL + 'api/doctype/List', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.evraktipi = response.body

    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })

  }



  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function CarihareketGetir() {
    this.dialogfiltre=false;

    this.$validator.validateAll().then((result) => {

      if (result) {

        var bastarih = new Date(this.date)
        var bittarih = new Date(this.date2)

        if (bastarih <= bittarih) {


          var credentials = JSON.parse(window.localStorage.getItem('credentials'));

          this.progress = true


          if (this.date == null) {
            this.date = getDateNow()
          }

          if (this.date2 == null) {
            this.date2 = getDateNow()
          }

          this.CariHareketInput.BaslangicTarihi=this.date
    this.CariHareketInput.BitisTarihi=this.date2
    this.CariHareketInput.SirketKodu=credentials.SirketKodu


          this.load1 = false
          this.load = true
          var Params = this.CariHareketInput

          this.$http.post(auth.API_URL + 'api/movement/index', Params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.progress = false
            this.load1 = true
            this.load = false

          }, (response) => {
            if (response.status === 0) {
              this.error = 'Service Unavailable'
              this.load1 = true
              this.progress = false
              this.error = false
            } else {
              this.error = response.statusText
              this.load1 = true
              this.progress = false
              this.error = false

            }
          })
        } else {
          this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
          this.snackbar = true
        }
      }
    })
  }
</script>

<style>
</style>